<span matDialogTitle>
  {{ 'Importa template' | siaTranslate }}
</span>

<button mat-icon-button matDialogClose>
  <mat-icon>close</mat-icon>
</button>
<div class="p-4" matDialogContent>
  <sia-json-editor [(jsonCode)]="data"></sia-json-editor>
</div>
<div matDialogActions align="end">
  <button mat-button (click)="import()">{{ 'Importa' | siaTranslate }}</button>
</div>
